/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import { IImage, IVideo } from '@/common/interface';
import {
  IKASPU,
  ILeadingSPU,
  IPlatformSPU,
  IResKASPUDetail,
  IResLeadingSPUDetail,
  IResPlatformSPUDetail,
  IResSPU,
  ISPU,
  ISPUCategory,
  ISPUProduct,
  TSPUPlatFlag,
  ISPUServices,
  IResSPUServices,
} from '@/common/interface/spu';

/** 普通商品 */
export class SPU implements ISPU {
  category: ISPUCategory = {
    id: 0,
    name: '',
  };
  headlineImage: IImage = {
    id: 0,
    url: '',
  };
  effectiveTimes = 1;
  isCombo = false;
  id = 0;
  isHot = false;
  isPreferred: any = false;
  name = '';
  newUserPriceCent = 0;
  originalPriceCent = 0;
  vipPriceCent = 0;
  isOnline = false;
  isAutoBrand = 0;
  unavailableTime: number[] = [];
  images: IImage[] = [];
  introduction = '';
  products: ISPUProduct[] = [];

  hasNewUserPrice = false;
  platFlag = 0 as TSPUPlatFlag;
  indicativePrice = 0;
  noticeInfos: any[] = [];

  refund_expire_conf = 'day:60';


  static from(data: IResSPU) {
    const spu = new SPU();
    spu.category = data.category;
    spu.headlineImage = data.headlineImage;
    spu.effectiveTimes = data.effectiveTimes;
    spu.id = data.id;
    spu.isHot = data.isHot;
    spu.isPreferred = typeof data.isPreferred === 'boolean' ? data.isPreferred : data.isPreferred === 1;
    spu.refund_expire_conf = data.refund_expire_conf || 'day:60';
    spu.name = data.name;
    spu.newUserPriceCent = data.newUserPriceCent;
    spu.originalPriceCent = data.originalPriceCent;
    spu.vipPriceCent = data.vipPriceCent;
    spu.isOnline = data.isOnline;
    spu.isAutoBrand = data.isAutoBrand ? 1 : 0;
    spu.unavailableTime = data.unavailableTime;
    spu.introduction = data.introduction;
    spu.platFlag = data.platFlag;
    spu.isCombo = data.effectiveTimes > 1;
    spu.hasNewUserPrice = data.newUserPriceCent > 0;
    spu.images = data.images || ([] as IImage[]);
    spu.noticeInfos = data.noticeInfos || [];


    if (data.products && data.products.length) {
      spu.products = data.products;
    }
    return spu;
  }
}

/** 平台标准商品 */
export class PlatformSPU implements IPlatformSPU {
  indicativePrice = 0;
  headlineImages: IImage[] = [];
  isAutoOffShelf = false;
  autoOffShelfTime = '';
  isAutoOnShelf = false;
  autoUpShelfTime = '';
  tempSpuShopPois = '';
  shortComment = '';
  commissionRatio = 0;
  isDrawCommission = false;
  videos: IVideo[] = [];
  createTime?: string;
  category: ISPUCategory = {
    id: 0,
    name: '',
  };
  headlineImage: IImage = {
    id: 0,
    url: '',
  };
  effectiveTimes = 1;
  isCombo = false;
  id = 0;
  isHot = false;
  isPreferred = false;

  isAutoBrand = 0;
  name = '';
  newUserPriceCent = 0;
  originalPriceCent = 0;
  vipPriceCent = 0;
  isOnline = false;
  unavailableTime: number[] = [];
  images: IImage[] = [];
  introduction = '';
  products: ISPUProduct[] = [];

  hasNewUserPrice = false;
  platFlag = 1 as TSPUPlatFlag;
  multi = 0;
  stock = '';
  noticeInfos: any[] = [];
  purchasePrice = 0;
  selfOperated = 0;
  refund_expire_conf = 'day:60';
  static from(data: IResPlatformSPUDetail) {
    const spu = new PlatformSPU();
    spu.category = data.category;
    spu.headlineImage = data.headlineImage;
    spu.effectiveTimes = data.effectiveTimes;
    spu.id = data.id;
    spu.isHot = data.isHot;
    spu.isPreferred = data.isPreferred === 1;
    spu.name = data.name;
    spu.newUserPriceCent = data.newUserPriceCent;
    spu.originalPriceCent = data.originalPriceCent;
    spu.vipPriceCent = data.vipPriceCent;
    spu.isOnline = data.isOnline;
    spu.isAutoBrand = data.isAutoBrand ? 1 : 0;
    spu.refund_expire_conf = data.refund_expire_conf || 'day:60';
    spu.unavailableTime = data.unavailableTime;
    spu.introduction = data.introduction;
    spu.platFlag = data.platFlag;
    spu.isCombo = data.effectiveTimes > 1;
    spu.autoOffShelfTime = data.autoOffShelfTime;
    spu.autoUpShelfTime = data.autoUpShelfTime;
    spu.hasNewUserPrice = data.newUserPriceCent > 0;
    spu.images = data.images || ([] as IImage[]);
    spu.videos = data.videos || [];
    spu.headlineImages = [data.headlineImage].concat(
      data.headlineOtherImage || [],
    );
    spu.purchasePrice = data.purchasePrice || 0;
    spu.selfOperated = data.selfOperated || 0;
    spu.multi = data.multi || 0;
    spu.stock = data.stock || '';
    spu.noticeInfos = data.noticeInfos || [];

    if (data.products && data.products.length) {
      spu.products = data.products;
    }
    const { tempSpuShopPois, isDrawCommission, shortComment, commissionRatio } =
      data.platformProduct;
    spu.tempSpuShopPois = tempSpuShopPois;
    spu.isDrawCommission = isDrawCommission === 1;
    spu.shortComment = shortComment;
    spu.commissionRatio = commissionRatio;

console.log('data.platformProduct', spu);
    return spu;
  }
}

/** 品牌标准商品 */
export class KASPU implements IKASPU {
  ka?: string | undefined;
  ka_id?: number;
  tyreTag?: string | undefined;
  tyreSpec?:
    | {
      tyreType?: string | undefined;
      tyreWidth?: string | number | undefined;
      tyreRatio?: string | number | undefined;
      tyreDiameter?: string | number | undefined;
    }
    | undefined;
  tyreType?: string | undefined;
  tyreWidth?: string | number | undefined;
  tyreRatio?: string | number | undefined;
  tyreDiameter?: string | number | undefined;
  indicativePrice = 0;
  headlineImages: IImage[] = [];
  tempSpuShopIds = '';
  shortComment = '';
  isDrawCommission = false;
  isAutoOffShelf = false;
  autoOffShelfTime = '';
  isAutoOnShelf = false;
  autoUpShelfTime = '';
  videos: IVideo[] = [];
  createTime?: string;
  category: ISPUCategory = {
    id: 0,
    name: '',
  };
  headlineImage: IImage = {
    id: 0,
    url: '',
  };
  effectiveTimes = 1;
  isCombo = false;
  id = 0;
  isHot = false;
  isPreferred = false;

  name = '';
  newUserPriceCent = 0;
  originalPriceCent = 0;
  vipPriceCent = 0;
  commissionRatio = 0;
  isOnline = false;
  isAutoBrand = 0;
  unavailableTime: number[] = [];
  images: IImage[] = [];
  introduction = '';
  products: ISPUProduct[] = [];

  hasNewUserPrice = false;
  platFlag = 1 as TSPUPlatFlag;
  noticeInfos: any[] = [];
  refund_expire_conf = 'day:60';


  static from(data: IResKASPUDetail) {
    const spu = new KASPU();
    spu.category = data.category;
    spu.headlineImage = data.headlineImage;
    spu.effectiveTimes = data.effectiveTimes;
    spu.id = data.id;
    spu.isHot = data.isHot;
    spu.isPreferred = data.isPreferred === 1;
    spu.name = data.name;
    spu.newUserPriceCent = data.newUserPriceCent;
    spu.originalPriceCent = data.originalPriceCent;
    spu.vipPriceCent = data.vipPriceCent;
    spu.isOnline = data.isOnline;
    spu.isAutoBrand = data.isAutoBrand ? 1 : 0;
    spu.unavailableTime = data.unavailableTime;
    spu.introduction = data.introduction;
    spu.platFlag = data.platFlag;
    spu.isCombo = data.effectiveTimes > 1;
    spu.autoOffShelfTime = data.autoOffShelfTime;
    spu.autoUpShelfTime = data.autoUpShelfTime;
    spu.hasNewUserPrice = data.newUserPriceCent > 0;
    spu.images = data.images || ([] as IImage[]);
    spu.videos = data.videos || [];
    spu.headlineImages = [data.headlineImage].concat(
      data.headlineOtherImage || [],
    );
    spu.noticeInfos = data.noticeInfos || [];
    spu.refund_expire_conf = data.refund_expire_conf || 'day:60';
    if (data.products && data.products.length) {
      spu.products = data.products;
    }
    if (data.ext_json) {
      const { aspectRatio, sectionWidth, tireType, tireTag, wheelDiameter } =
        data.ext_json;
      spu.tyreTag = tireTag || '';
      spu.tyreSpec = {
        tyreDiameter: wheelDiameter,
        tyreRatio: aspectRatio,
        tyreWidth: sectionWidth,
        tyreType: tireType,
      };
    }
    const { isDrawCommission, shortComment, commissionRatio } = data.platformProduct;
    spu.tempSpuShopIds = data.tempSpuShopIds;
    spu.commissionRatio = commissionRatio;

    spu.isDrawCommission = isDrawCommission === 1;
    spu.shortComment = shortComment;

    return spu;
  }
}

/** 批量操作/多门店商品 */
export class LeadingSPU implements ILeadingSPU {
  autoOffShelfTime = '';
  isAutoOffShelf = false;
  tempSpuShopIds = '';
  autoUpShelfTime = '';
  isAutoOnShelf = false;
  category: ISPUCategory = {
    id: 0,
    name: '',
  };
  headlineImage: IImage = {
    id: 0,
    url: '',
  };
  effectiveTimes = 1;
  isCombo = false;
  id = 0;
  isHot = false;
  isPreferred = false;

  name = '';
  newUserPriceCent = 0;
  originalPriceCent = 0;
  vipPriceCent = 0;
  isOnline = false;
  isAutoBrand = 0;
  unavailableTime: number[] = [];
  images: IImage[] = [];
  introduction = '';
  products: ISPUProduct[] = [];

  hasNewUserPrice = false;
  platFlag = 2 as TSPUPlatFlag;
  indicativePrice = 0;
  filterTag = '';
  remark = '';
  noticeInfos: any[] = [];
  refund_expire_conf = 'day:60';
  static from(data: IResLeadingSPUDetail) {
    const spu = new LeadingSPU();
    spu.category = data.category;
    spu.headlineImage = data.headlineImage;
    spu.effectiveTimes = data.effectiveTimes;
    spu.id = data.id;
    spu.isHot = data.isHot;
    spu.isPreferred = data.isPreferred === 1;
    spu.name = data.name;
    spu.newUserPriceCent = data.newUserPriceCent;
    spu.originalPriceCent = data.originalPriceCent;
    spu.vipPriceCent = data.vipPriceCent;
    spu.isOnline = data.isOnline;
    spu.isAutoBrand = data.isAutoBrand ? 1 : 0;
    spu.unavailableTime = data.unavailableTime;
    spu.introduction = data.introduction;
    spu.platFlag = data.platFlag;
    spu.isCombo = data.effectiveTimes > 1;
    spu.autoOffShelfTime = data.autoOffShelfTime;
    spu.autoUpShelfTime = data.autoUpShelfTime;
    spu.hasNewUserPrice = data.newUserPriceCent > 0;
    spu.refund_expire_conf = data.refund_expire_conf || 'day:60';
    spu.images = data.images || ([] as IImage[]);
    spu.tempSpuShopIds = data.tempSpuShopIds;
    spu.noticeInfos = data.noticeInfos || [];

    if (data.products && data.products.length) {
      spu.products = data.products;
    }
    if (data.note_tag) {
      spu.filterTag = data.note_tag;
    }
    if (data.remark) {
      spu.remark = data.remark;
    }

    return spu;
  }
}


export class SpuServicesList implements IResSPUServices {
  firstCategory = '';
  secondCategory = '';
  item = '';
  category = 0;
  required = 0;
  createUser = '';
  createdAt = '';
  status = 0;
  id = 0;


  static from(data: ISPUServices) {
    const spu = new SpuServicesList();
    spu.firstCategory = data.first_category;
    spu.secondCategory = data.second_category;
    spu.item = data.item;
    spu.category = data.category;
    spu.required = data.required;
    spu.createUser = data.create_user;
    spu.createdAt = data.created_at;
    spu.status = data.status;
    spu.id = data.id;
    return spu;
  }
}

